<template>
  <section class="main-container">
    <Top></Top>
    <div class="main-content-wrap">
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
import Top from '@/components/top.vue'
import Footer from '@/components/footer.vue'
export default {
  name: 'App',
  components: {
    Top,
    Footer
  }
}
</script>

<style>

</style>
